import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import "./ModalLoadSpinner.css"; // Import the custom CSS below
import { useState } from "react";

export default function ModalLoadSpinner({ message }: { message?: string }) {
  const [visible, setVisible] = useState(true);

  return (
    <Dialog
      visible={true}
      closable={false} // Professional loaders usually shouldn't be closable by the user
      showHeader={false} // Removes the header bar for a cleaner "splash" look
      modal
      className="custom-loading-dialog"
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
    >
      <div className="loading-container">
        <ProgressSpinner strokeWidth="3" animationDuration=".8s" />
        <span className="loading-text">{message || "Por favor espere..."}</span>
      </div>
    </Dialog>
  );
}
